import { TheWestSection } from '@news-mono/common'
import { StaticRoute, StaticRoutes } from '@news-mono/web-common'
import { getSwgLandingPage } from '../regionals/get-swg-landing-page'

const bannerImage = {
    x1: require('./assets/2023-SWG-Uni-Student-Offer-Mobile-450x250px.jpg'),
    x2: require('./assets/2023-SWG-Uni-Student-Comp-Banner-1980x1080px.jpg'),
}

const createUniversityOfferPage: StaticRoute<TheWestSection> = (services) => {
    if (!services.store.getState().toggles['university-offering']) return null
    return getSwgLandingPage({
        section: 'default',
        getAdTargeting: services.getAdTargeting,
        options: {
            heading: 'The West Australian is proud to offer you this exclusive offer of a 12 month digital subscription for only $1 per month thanks to our partnership with Google.',
            bannerImage,
            modifier: 'university-offer',
            originalPrice: '$7 per week',
            promoPrice: '$1 per month for the first 12 months*',
            googleSku: 'everyday_digital_curtin_university',
            headerFontSize: 59,
            noIndex: true,
            infoMessage:
                '*Subscribe today with Google. Cancel anytime 4 weeks minimum.',
        },
    })
}

export const getUniversityOfferRouteInfo: StaticRoutes<TheWestSection> = {
    '/university-offer': createUniversityOfferPage,
}
